export const FormType = Object.freeze({
  VIEW: 'VIEW',
  NEW: 'NEW',
  EDIT: 'EDIT',
});
